<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

@if (!isLoading) {
  <ziro-voicemail
    [username]="username"
    [siteId]="siteId"
    (voicemailDeleted)="onVoicemailDelete()"
    (voicemailSaved)="onVoicemailSave()"
  ></ziro-voicemail>
}
